import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

const Reporting: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Placeholder Sidebar */}
      <Box
        sx={{
          height: '100vh',
          position: 'fixed',
          top: 0,
          paddingTop: '64px',
          left: 0,
          backgroundColor: 'background.paper',
          width: isMobile ? '12vw' : '3vw',
          borderRight: `1px solid ${theme.palette.divider}`,
        }}
      />

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          padding: 3,
          marginLeft: isMobile ? '12vw' : '3vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography variant="h4" color="text.secondary">
          Reporting Page Placeholder
        </Typography>
      </Box>
    </Box>
  );
};

export default Reporting;
